<template>
  <div class="home">
    <HeaderView />
    <BannerView />
    <section class="section1">
      <div class="container">
        <div class="s1-content">
          <div class="s1-content-left">
            <p class="home-title">{{ i18n[lang].about }}</p>
            <p class="s-title" v-html="IndexData.about_title"></p>
            <p class="home-desc" v-html="IndexData.about_brief"></p>
            <!-- 探索更多按钮 -->
            <button class="explore-btn" @click="$router.push('/about')">
              {{ i18n[lang].explore }}
              <span class="arrow-circle">
                <svg class="arrow-icon" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M0 8h14m-4-4 4 4-4 4"
                    stroke="#1890ff"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
              </span>
            </button>
          </div>

          <div class="s1-content-right wow fadeInRight">
            <div
              class="num-item"
              v-for="(desc, num, idx) in numItems"
              :key="num"
            >
              <div class="left">
                <div class="s1-num">{{ num }}</div>
                <div class="s1-desc">{{ desc }}</div>
              </div>
              <img :src="`imgs/home/images/tubiao${idx + 1}.jpg`" alt="" />
            </div>
          </div>
        </div>
        <div class="s1-imgbox wow fadeInLeft" :class="{ 'lang-ru': lang === 'RU', 'lang-en': lang === 'EN' }">
          <img :src="IndexData.about_image" alt="" />
          <span>{{ i18n[lang].imgtextproject }}</span>
        </div>
      </div>
    </section>

    <section class="section2">
      <div class="container">
        <!-- <p class="home-title">销售网络</p>
        <p class="s-title">
          乘“中欧班列”，沿“一带一路”
          <br /><span style="color: #e53935">从中国到世界</span>
        </p> -->
        <p class="home-title">{{ i18n[lang].sales }}</p>
        <p class="s-title">
          {{ i18n[lang].salestext1 }}
          <br /><span style="color: #e53935">{{ i18n[lang].salestext2 }}</span>
        </p>
        <div class="s2-content">
          <MapView />
          <div class="service-container  wow fadeInRight">
            <div
              class="service-card"
              v-for="item in networkList"
              :key="item.id"
            >
              <img :src="item.image" :alt="item.title" class="card-img" />
              <div class="card-content">
                <h3 class="card-title">{{ item.title }}</h3>
                <p class="card-desc" v-html="item.brief"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section3">
      <div class="container">
        <p class="home-title">{{ i18n[lang].news }}</p>
        <div class="news-box">
          <div
            class="news-item"
            v-if="newsList.length > 0"
            @click="
              $router.push({
                path: '/newsDetail',
                query: { id: newsList[0].id, lang: lang },
              })
            "
          >
            <div class="news-date">{{ newsList[0].create_time }}</div>
            <div class="news-title">
              {{ newsList[0].title }}
            </div>
            <div class="news-desc" v-html="newsList[0].brief"></div>
            <span href="#" class="news-link">{{ i18n[lang].explore2 }}&gt;</span>
            <img :src="newsList[0].image" alt="" class="news-img" />
          </div>

          <div class="news-item2" v-if="newsList.length > 1">
            <div
              class="news-s"
              v-if="newsList.length > 1"
              @click="
                $router.push({
                  path: '/newsDetail',
                  query: { id: newsList[1].id, lang: lang },
                })
              "
            >
              <div class="news-date">{{ newsList[1].create_time }}</div>
              <div class="news-title">
                {{ newsList[1].title }}
              </div>
              <div class="news-desc2" v-html="newsList[1].brief"></div>
              <span href="#" class="news-link2">{{ i18n[lang].explore2 }}&gt;</span>
            </div>
            <div
              class="news-s"
              v-if="newsList.length > 2"
              @click="
                $router.push({
                  path: '/newsDetail',
                  query: { id: newsList[2].id, lang: lang },
                })
              "
            >
              <div class="news-date">{{ newsList[2].create_time }}</div>
              <div class="news-title">
                {{ newsList[2].title }}
              </div>
              <div class="news-desc2" v-html="newsList[2].brief"></div>
              <span href="#" class="news-link2">{{ i18n[lang].explore2 }}&gt;</span>
            </div>
          </div>
          <div
            class="news-item3"
            :style="{
              backgroundImage:
                'url(' +
                ((newsList[3] && newsList[3].h_image) ||
                  '/imgs/home/images/news-img2_03.png') +
                ')',
            }"
            v-if="newsList.length > 3"
            @click="
              $router.push({
                path: '/newsDetail',
                query: { id: newsList[3].id, lang: lang },
              })
            "
          >
            <div class="news3-text">
              <div class="news-date3">{{ newsList[3].create_time }}</div>
              <div class="news-title3">
                {{ newsList[3].title }}
              </div>
              <div class="news-desc3" v-html="newsList[3].brief"></div>
              <span href="#" class="news-link3">{{ i18n[lang].explore2 }}&gt;</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section4">
      <div class="container">
        <p class="home-title">{{ i18n[lang].partner }}</p>
        <span class="home-desc"> Become our partner </span>
        <div class="logo-grid">
          <div
            v-for="(item, index) in cooperationList"
            :key="item.id"
            :class="[
              'logo-item',
              index % 5 === 0
                ? 'logo-item1'
                : index % 5 === 1
                ? 'logo-item2'
                : '',
            ]"
          >
            <!-- @mouseenter="$event.target.src = item.image"
          @mouseleave="$event.target.src = item.b_image" -->
            <img :src="item.image" :alt="'logo'" />
          </div>
        </div>

        <div class="end-imgbox">
          <div class="end-textbox">
            <!-- <h2>全球客户的共同选择</h2> -->
            <h2>{{ i18n[lang].endchoose }}</h2>
            <p>A Sample list of ou happy custemers from around the woekd</p>
            <button class="explore-btn" @click="$router.push('/contact')">
              {{ i18n[lang].explore2 }}
              <span class="arrow-circle">
                <svg class="arrow-icon" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M0 8h14m-4-4 4 4-4 4"
                    stroke="#1890ff"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
              </span>
            </button>
          </div>
        </div>
      </div>
    </section>
    <FooterView />
  </div>
</template>

<script>
//交互式3D地球 https://www.isqqw.com/viewer?id=36980

import HeaderView from "@/components/HeaderView.vue";
import FooterView from "@/components/FooterView.vue";
import BannerView from "@/components/BannerView.vue";
import MapView from "@/components/3DmapView.vue";
import WOW from 'wow.js'
import 'animate.css'
import apiServe from "@/services/index.js";
export default {
  name: "HomeView",
  components: {
    HeaderView,
    FooterView,
    BannerView,
    MapView,
  },
  data() {
    return {
      lang: "CN",
      i18n: {
        CN: {
          about: '关于同升',
          explore: '探索更多',
          imgtextproject: '俄罗斯TZJ40高寒拖挂钻机项目',
          sales: '销售网络',
          salestext1: '乘“中欧班列”，沿“一带一路”',
          salestext2: '从中国到世界',
          news: '新闻动态',
          explore2: '了解更多',
          partner: '合作伙伴',
          endchoose: '全球客户的共同选择',
        },
        EN: {
          about: 'ABOUT US',
          explore: 'EXPLORE MORE',
          imgtextproject: 'Project TZJ40- -4000 meters drilling rig in Russian',
          sales: 'Sales Area',
          salestext1: 'Sailing the "Eastern European Train" along the "Belt and Road"',
          salestext2: 'From China to the World',
          news: 'NEWS',
          explore2: 'Learn More',
          partner: 'PARTNER',
          endchoose: 'Global Customer Choices',
        },
        RU: {
          about: 'О компании Tongsheng',
          explore: 'Исследуйте больше',
          imgtextproject: 'Проект TZJ40-- 4000 метровой буровой установки в России',
          sales: 'Регионы продаж',
          salestext1: 'Путешествие по "Европейскому поезду" вдоль "Битвы и дороги"',
          salestext2: 'Из Китая в мир',
          news: 'Новости компании',
          explore2: 'Узнать больше',
          partner: 'Партнеры',
          endchoose: 'Глобальные выборы клиентов',
        }
      },
      IndexData: {},
      numItems: {},
      newsList: [],
      cooperationList: [],
      networkList: [],
    };
  },
  created() {
    const saved = localStorage.getItem("lang");
    if (saved) this.lang = saved;
  },
  mounted() {
    this.getIndexData();
    // 为logo-item1元素添加hover图片切换效果
    const logoItems = document.querySelectorAll(".logo-item1 img");
    logoItems.forEach((img) => {
      const originalSrc = img.src;
      img.addEventListener("mouseover", () => {
        img.src = "/img/business/images/logo1-c_03.png";
      });
      img.addEventListener("mouseout", () => {
        img.src = originalSrc;
      });
    });
    // 为logo-item2元素添加hover图片切换效果
    const logoItems2 = document.querySelectorAll(".logo-item2 img");
    logoItems2.forEach((img) => {
      const originalSrc = img.src;
      img.addEventListener("mouseover", () => {
        img.src = "/img/business/images/logo2-c_03.png";
      });
      img.addEventListener("mouseout", () => {
        img.src = originalSrc;
      });
    });
    // 初始化进入视口动画
    this.initScrollAnimation();
    // 初始化 WOW.js 动画
    this.initWOW();
  },
  methods: {
    initScrollAnimation() {
      // 定义需要动画的元素
      const animateEls = [
        '.section1',
        '.section2',
        '.section3',
        '.section4',
        '.s1-content-left',
        '.news-box',
        '.logo-grid',
        '.end-imgbox'
      ];
      // 给元素添加 animate 类并设置初始透明
      animateEls.forEach(selector => {
        const el = document.querySelector(selector);
        if (el) {
          el.classList.add('animate');
        }
      });
      // 同步检测首屏元素
      this.checkAnimated();
      // 使用 IntersectionObserver 监听进入视口
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animated');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
      document.querySelectorAll('.animate').forEach(el => observer.observe(el));
    },
    checkAnimated() {
      // 首屏元素立即触发，避免闪烁
      document.querySelectorAll('.animate').forEach(el => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          el.classList.add('animated');
        }
      });
    },
    getIndexData() {
      const data = {
        lang: this.lang,
      };
      apiServe.getIndexData(data).then((res) => {
        this.IndexData = res.data;
        this.newsList = res.data.news;
        // 解析about_num JSON字符串
        if (res.data.about_num) {
          this.numItems = JSON.parse(res.data.about_num);
        }
        // 对接合作伙伴数据
        if (res.data.partner) {
          this.cooperationList = res.data.partner;
        }
        // 对接销售网络数据
        if (res.data.network) {
          this.networkList = res.data.network;
        }
      });
    },
    // 初始化 WOW.js 动画
    initWOW() {
      new WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        mobile: true,
        live: true
      }).init();
    }
  },
};
</script>
<!-- npm install wow.js animate.css -->
<style src="@/assets/animate.css">
  
</style>
<style lang="scss" scoped>
.s2-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.section4 {
  background-image: url("/public/imgs/home/images/s4bg_14.png");
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: top;
}
.logo-grid {
  width: 100%;
  margin: 5rem auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 3rem 0;
}
.logo-item {
  flex: 0 0 auto;
  width: calc(100% / 7 - 0.5rem);
  overflow: hidden;
}
.logo-item img {
  width: 140px;
  transition: transform 0.3s ease;
}
.logo-item img:hover {
  transform: scale(1.2);
}
.end-imgbox {
  width: 100%;
  height: 510px;
  margin: 2rem auto;
  background-image: url("/public/imgs/home/images/end_15.png");
  background-size: cover;
  background-position: center;
  position: relative;
  border-radius: 20px;
}
.end-textbox {
  position: absolute;
  top: 50%;
  left: 20%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #fff;
  font-family: "Source_Han_Sans_SC_Normal";
}
.end-textbox h2 {
  font-size: 2.5rem;
  margin-bottom: 0.5rem;
}
.s1-content {
  height: 600px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.s1-content-left {
  width: 68%;
}
.home-title {
  font-size: 3.5rem;
  // font-weight: bold;
  margin-bottom: 2.5rem;
}
.home-desc {
  font-family: "Source_Han_Sans_SC_Light";
  font-size: 1.1rem;
}
.s-title {
  font-size: 2rem;
  margin-bottom: 1.5rem;
}

.explore-btn {
  display: inline-flex;
  gap: 3rem;
  align-items: center;
  padding: 12px 24px;
  background: #f0f0f0;
  border: none;
  border-radius: 24px;
  font-size: 16px;
  color: #333;
  cursor: pointer;
  transition: background 0.3s;
  margin-top: 2rem;
}
.explore-btn:hover {
  background: #1890ff;
  color: #fff;
}
.explore-btn:hover .arrow-circle {
  background-color: #fff;
}
.explore-btn:hover .arrow-icon path {
  stroke: #1890ff;
}

.arrow-circle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  // background: #1890ff;
  background-color: #fff;
  border-radius: 50%;
  margin-left: 8px;
}
.arrow-icon {
  width: 16px;
  height: 16px;
}

.s1-content-right {
  width: 25%;
}
.num-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 10px;
  border-bottom: 1px solid #eee;
}
.left {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.s1-num {
  font-size: 45px;
  // font-weight: bold;
  color: #e53935; /* 红色 */
}
.s1-desc {
  font-size: 14px;
  color: #666;
}

.s1-imgbox {
  margin-top: -5rem;
  position: relative;
}
.s1-imgbox img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.s1-imgbox span {
  position: absolute;
  top: 93%;
  left: 82%;
  font-size: 18px;
  color: #fff;
}
.s1-imgbox.lang-ru span {
  top: 90%;
  left: 65%;
}
.s1-imgbox.lang-en span {
  left: 70%;
}

.section2 {
  // padding: 60px 0;
  background-image: url("https://img.isqqw.com/profile/upload/2024/11/12/33333333-3333-3333-3333-333333333333.jpg");
  background-size: cover;
  background-position: center;
  background-color: #edf0f7;
}
.section3 {
  // padding: 60px 0;
  background-image: url("/public/imgs/home/images/news-bg_02.png");
  background-size: cover;
  background-position: center;
}
// ----------3d-right----------
.service-container {
  max-width: 600px;
  height: 720px;
  overflow-y: auto;
  margin: 0 auto;
  padding: 0 50px;
  position: relative;
}

/* 自定义滚动条样式 */
.service-container::-webkit-scrollbar {
  width: 6px; /* 滚动条宽度 */
}

.service-container::-webkit-scrollbar-track {
  background: #c5c5c6; /* 轨道灰色 */
  border-radius: 3px;
}

.service-container::-webkit-scrollbar-thumb {
  background: #1890ff; /* 滑块蓝色 */
  border-radius: 3px; /* 进度条形状 */
}
.service-card {
  background: #fff;
  border-radius: 25px;
  box-shadow: 17px 20px 33px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  padding: 16px;
  margin-bottom: 20px;
  gap: 2rem;
}
.card-img {
  width: 175px;
  height: 180px;
  border-radius: 15%;
  object-fit: cover;
}
.card-content {
  flex: 1;
  padding: 0 35px;
}
.card-title {
  font-size: 35px;
  // font-weight: 600;
  margin-bottom: 8px;
}
.card-desc {
  font-family: "Source_Han_Sans_SC_Normal";

  font-size: 20px;
  color: #666;
  margin-bottom: 12px;
}
.card-btn {
  font-size: 14px;
  color: #4080ff;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.card-btn::after {
  content: "→";
  font-size: 12px;
}

// ---------------------
.news-box {
  display: flex;
  justify-content: space-between;
  // align-items: center;
  // gap: 20px;
}
.news-item {
  width: 425px;
  height: 700px;
  background-color: #fff;
  border-radius: 15px;
  padding: 30px 50px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  cursor: pointer;
}
.news-item2 {
  width: 505px;
  // height: 720px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  // gap: 2.25rem;
}

.news-s {
  width: 82%;
  // height: 45%;
  background-color: #fff;
  border-radius: 15px;
  padding: 30px 50px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  cursor: pointer;
}
.news-item3 {
  background-image: url("/public/imgs/home/images/news-img2_03.png");
  background-size: cover;
  background-position: center;
  width: 425px;
  height: 700px;
  background-color: #fff;
  border-radius: 15px;
  padding: 30px 50px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
  cursor: pointer;
}
.news-item3::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to top, #5a7891 0%, transparent 100%);
  pointer-events: none;
  z-index: 1;
}
.news-item,.news-s,.news-item3 {
  transition: transform 0.3s ease-in-out;
}
.news-item:hover,.news-s:hover,.news-item3:hover {
  transform: translateY(-10px);
 
}
.news-item:hover .news-link {
    color: #007bff;
}
.news-s:hover .news-link2 {
    color: #007bff;
}
.news-item3:hover .news-link3 {
    color: #007bff;
}
.news3-text {
  margin-top: 90%;
  color: #fff;
  position: relative;
  z-index: 2;
  // position: absolute;
  // top: 65%;
  // left: 0%;
  // transform: translate(-50%, -50%);
}
.news-date {
  color: #ff4444;
  font-size: 14px;
  margin-bottom: 10px;
}
.news-title {
  font-size: 23px;
  // font-weight: bold;
  margin-bottom: 10px;
  /* 设置超出隐藏 */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.news-desc {
  font-size: 19px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
  flex: 1;
  /* 设置超出隐藏 */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}
.news-desc2 {
  font-size: 19px;
  color: #666;
  line-height: 1.6;
  // margin-bottom: 20px;
  flex: 1;
  min-height: 150px;
  /* 设置超出隐藏 */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.news-link {
  color: #333;
  font-size: 16px;
  text-decoration: none;
  margin-bottom: 60px;
}
.news-link2 {
  color: #333;
  font-size: 16px;
  text-decoration: none;
  margin-bottom: 20px;
}
.news-link:hover {
  color: #007bff;
}
.news-link2:hover {
  color: #007bff;
}
.news-link3:hover {
  color: #007bff;
}
.news-date3 {
  color: #fff;
  font-size: 14px;
  margin-bottom: 10px;
}
.news-title3 {
  font-size: 23px;
  // font-weight: bold;
  margin-bottom: 10px;
  color: #fff;
}
.news-desc3 {
  font-size: 19px;
  color: #fff;
  line-height: 1.6;
  margin-bottom: 20px;
  flex: 1;
  /* 设置超出隐藏 */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.news-img {
  width: 100%;
  height: 300px;
  object-fit: cover;
  border-radius: 20px;
}

.section4 .home-title {
  margin-bottom: 0;
}
.section4 .home-desc {
  display: block;
  margin-top: 0;
  margin-left: 30px;
}

/* ========== 移动端适配 ========== */
@media (max-width: 768px) {
  .s2-content {
    flex-direction: column;
    height: auto;
  }
  .container {
    width: 90%;
    padding: 0 5%;
  }
  .home-title {
    font-size: 2rem;
  }
  .s-title {
    font-size: 1.5rem;
  }
  .home-desc {
    font-size: 1rem;
  }
  .s1-content {
    flex-direction: column;
    height: auto;
  }
  .s1-imgbox {
    margin-top: 2rem;
    position: relative;
  }
  .s1-content-left,
  .s1-content-right {
    width: 100%;
  }
  .s1-imgbox span {
    font-size: 1.2rem;
    left: 50%;
    top: 80%;
    transform: translateX(-50%);
  }
  .service-container {
    max-width: 100%;
  }
  .service-card {
    flex-direction: column;
    text-align: center;
  }
  .news-box {
    flex-direction: column;
    align-items: center;
  }
  .news-item,
  .news-item3 {
    width: 78%;
    height: auto;
    margin-bottom: 1rem;
  }
  .news-item2 {
    width: 100%;
    height: auto;
    margin-bottom: 1rem;
    gap: 1rem;
  }
  .news-s {
    width: 70%;
  }
  .logo-grid {
    width: 100%;
    gap: 1rem 0;
  }
  .logo-item {
    width: calc(100% / 3 - 0.5rem);
  }
  .logo-item img {
    width: 100%;
  }
  .end-imgbox {
    height: 300px;
  }
  .end-textbox {
    width: 80%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .end-textbox h2 {
    font-size: 1.5rem;
  }

  /* ========== service-container 移动端适配 ========== */
  .service-container {
    width: 100%;
    height: auto;
    padding: 0;
    box-sizing: border-box;
    display: flex;
    overflow-x: auto;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
  }
  .service-card {
    flex: 0 0 70%;
    display: inline-block;
    text-align: center;
    padding: 12px;
    margin: 0 8px;
  }
  .card-img {
    width: 75%;
    height: auto;
    margin-bottom: 12px;
  }
  .card-content {
    padding: 0 12px;
  }
  .card-title {
    font-size: 1.1rem;
  }
  .card-desc {
    font-size: 0.9rem;
    width: 80%;
  }

  .explore-btn {
    padding: 12px 15px;
  }
}


/* 进入视口动画 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(90px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.animate {
  opacity: 0;
}
.animated {
  animation: fadeInUp 1.5s ease forwards;
}
</style>